import { render, staticRenderFns } from "./RelationshipFieldtype.vue?vue&type=template&id=35496677&"
import script from "./RelationshipFieldtype.vue?vue&type=script&lang=js&"
export * from "./RelationshipFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports